import { ComboboxItem, Select, Text, TextInput, Tooltip } from "@mantine/core";
import React, { useEffect, useState } from "react";
import classesButton from "../../../../../src/Styles/StyleButton.module.css";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../../../model/MessageResponse";
import { tblInventoryTransaction } from "../../../../model/TblOutWard";
import RenderTable from "./RenderTable";
import { SelectListItem } from "../../../../model/SelectListItem";
interface Inventory {
  inventoryId: number;
  inventoryName: string;
  parentId: number | null; // Nếu giá trị có thể null, sử dụng kiểu này
  inventoryCode: string;
  attribute3?: string;
}

const ExchangeReturnInWard = ({
  dataSearchSourceCodeOption,
  dataPosition,
  dataInWard,
  sourceCode,
  setSourceCode,
  handleKeyDownSourceCode,
  dataOrderDetail,
  handleChangeValueInput,
  isSave,
  setSearchSourceCode,
  isEdit,
  isLocked,
  haveStatus,
  haveSourceCode,
  action,
  dataSerialStatus,
  setSerialStatusSelectAll,
  dataSerialOnHand,
  dataBranch,
  dataInventoryTransactionType,
}: RequestOrderReturnInWardProps) => {
  const [idInventory, setIdInventory] = useState<string | null>(null);
  const [dataInventoryGroup, setDataInventoryGroup] = useState<Inventory[]>([]);
  const [codeAtt3Inv, setCodeAtt3Inv] = useState<string>("");
  // Đây là state lưu địa chỉ Xã phường mới
  const [dataCommuneMoi, setDataCommuneMoi] = React.useState<SelectListItem[]>(
    [],
  );
  const [datadiaChi, setDataDiaChi] = useState<{
    province?: string;
    district?: string;
    commune?: string;
  }>({});

  const isDisabled =
    dataInWard.status === "LOCK" ||
    sourceCode ||
    isSave ||
    ["DETAIL", "EDIT"].includes(action);
  const headers = [
    { label: "", style: { width: "25%" } },
    { label: "Bên xuất", style: { width: "25%" } },
    { label: "", style: { width: "25%" } },
    { label: "Bên nhận", style: { width: "25%" } },
  ];

  const getTblDmExpense = async () => {
    const response = await repositoryPos.get<MessageResponse<Inventory[]>>(
      `/api/v1/TblDmInventory/get-select-by-branch?branchId=${dataOrderDetail.toBranchId}`,
    );
    if (response && response.success) {
      let result = response.data;
      setDataInventoryGroup(result);
    }
  };

  const parseAttribute5 = (attribute5: string) => {
    if (!attribute5) return { name: null, phone: null };
    const parts = attribute5.split(" - ");
    return {
      name: parts[0]?.trim() || null,
      phone: parts[1]?.trim() || null,
    };
  };

  const attribute5Data = parseAttribute5(dataOrderDetail?.attribute5);

  useEffect(() => {
    if (dataOrderDetail.toBranchId) {
      getTblDmExpense();
    }
  }, [dataOrderDetail.toBranchId]);

  const getDeliveryText = (delivery: string) => {
    switch (delivery) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "NOI_BO":
      case "HA_COM":
        return "Nội bộ";
      default:
        return delivery;
    }
  };
  const attribute3 = dataOrderDetail?.attribute3;
  const checkDvtn = dataOrderDetail?.dvtn;
  let parsedData: any | null = null;

  try {
    parsedData = attribute3 ? JSON.parse(attribute3) : null;
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }
  useEffect(() => {
    if (dataOrderDetail) {
      let idCheck: string | undefined = undefined;
      let paramType: "Ids" | "OldCommuneId" | undefined = undefined;
      // NOTE:CHUYỂN ĐỔI LOGIC LẤY HẾT ĐỊA CHỈ MỚI LÊN CHỈ DÙNG TYPE LÀ IDS THÔI
      if (dataOrderDetail?.dvtn) {
        // nếu là đơn vị tiếp nhận thì mặc định truyền vào OldCommuneId
        idCheck = parsedData?.customerCommuneId;
        paramType = "Ids";
      } else if (dataOrderDetail?.newCommuneId && !dataOrderDetail?.dvtn) {
        idCheck = dataOrderDetail.newCommuneId;
        paramType = "Ids";
      } else if (dataOrderDetail?.cusCommuneId && !dataOrderDetail?.dvtn) {
        idCheck = dataOrderDetail.cusCommuneId;
        paramType = "Ids";
      }

      const fetchDataReceiptCommuneMoi = async () => {
        if (!idCheck || !paramType) return;
        const url = `/api/v1/TblDmCommuneMoi/get-select?${paramType}=${idCheck}`;
        const response =
          await repositoryMdm.get<MessageResponse<SelectListItem[]>>(url);

        if (response && response.success) {
          let result = response.data;
          setDataCommuneMoi(result);
        }
      };

      fetchDataReceiptCommuneMoi();
    }
  }, [dataOrderDetail]);
  // Logic sửa lại là nếu như màn danh sách đơn là chọn đơn địa chỉ cũ thì sẽ hiển thị địa chỉ cũ , nếu chọn địa chỉ mới thì sửa lại là lấy địa chỉ mới
  // useEffect(() => {
  //   if (dataOrderDetail) {
  //     let url: string | undefined;
  //     if (dataOrderDetail?.dvtn) {
  //       //dùng trường customerDistrictId để check nếu như có trường huyện này thì là địa chỉ cũ , nếu như k có trường này là địa chỉ mới
  //       if (parsedData?.customerDistrictId) {
  //         url = `/api/v1/TblDmCommune/get-list?Ids=${parsedData?.customerCommuneId}&Skip=0&Take=100`;
  //       } else {
  //         url = `/api/v1/TblDmCommuneMoi/get-select?Ids=${parsedData?.newCommuneId}`;
  //       }
  //     } else if (dataOrderDetail?.newCommuneId && !dataOrderDetail?.dvtn) {
  //       url = `/api/v1/TblDmCommuneMoi/get-select?Ids=${dataOrderDetail.newCommuneId}`;
  //     } else if (dataOrderDetail?.cusCommuneId && !dataOrderDetail?.dvtn) {
  //       url = `/api/v1/TblDmCommune/get-list?Ids=${dataOrderDetail.cusCommuneId}&Skip=0&Take=100`;
  //     }
  //     const fetchDataReceiptCommuneMoi = async () => {
  //       if (!url) return;
  //       const response = await repositoryMdm.get<MessageResponse<any[]>>(url);

  //       if (response && response.success) {
  //         let result = response.data;
  //         // setDataCommuneMoi(result);
  //         setDataDiaChi({
  //           province: result[0]?.provinceName || result[0]?.att1,
  //           district: result[0]?.districtName || "",
  //           commune: result[0]?.name || result[0]?.text,
  //         });
  //       }
  //     };

  //     fetchDataReceiptCommuneMoi();
  //   }
  // }, [dataOrderDetail]);
  // console.log("dataOrderDetailllll", dataOrderDetail);
  // console.log("datadiaChiiiia", datadiaChi);

  useEffect(() => {
    if (
      codeAtt3Inv === "BH" &&
      Array.isArray(dataPosition) &&
      dataPosition?.length > 0
    ) {
      const dataChange = dataPosition?.filter(
        (item) => item.code && /^BH\d+_XL$/.test(item.code),
      )[0]?.value;
      handleChangeValueInput(dataChange, "toPositionId");
    } else {
      handleChangeValueInput(null, "toPositionId");
    }
  }, [codeAtt3Inv, dataPosition]);

  const rows = [
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian tạo
          </Text>
        ),
      },
      { content: null },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOrderDetail?.createDate ?? "")}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian hoàn thành
          </Text>
        ),
      },
      { content: null },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataInWard?.finishDate)}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu nhập kho
          </Text>
        ),
      },
      { content: null },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataInWard?.transactionCode}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu yêu cầu nhập kho
          </Text>
        ),
      },
      {
        content:
          !isEdit && !haveSourceCode ? (
            <Tooltip
              label={
                dataInWard?.sourceCode
                  ? dataInWard?.sourceCode
                  : "Vui lòng chọn phiếu"
              }
            >
              <Select
                w={"160px"}
                placeholder="Mã phiếu yêu cầu nhập kho"
                data={dataSearchSourceCodeOption}
                size="sm"
                disabled={
                  !dataInWard.sourceType ||
                  dataInWard.status === "LOCK" ||
                  sourceCode ||
                  isSave
                }
                searchable
                clearable
                onSearchChange={(e) => {
                  if (setSearchSourceCode) {
                    setSearchSourceCode(e);
                  }
                }}
                onKeyDown={handleKeyDownSourceCode}
                value={sourceCode || dataInWard.sourceCode}
                onChange={(value) => {
                  if (handleChangeValueInput) {
                    handleChangeValueInput(value || "", "sourceCode");
                  }
                  if (setSourceCode) {
                    setSourceCode(value);
                  }
                }}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            </Tooltip>
          ) : (
            <Text
              w={"150px"}
              size="sm"
              style={{ whiteSpace: "normal" }}
              truncate
            >
              {dataInWard.sourceCode}{" "}
            </Text>
          ),
      },
      { content: null },
      { content: null },
    ],
    // [
    //   {
    //     content: (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         Lý do
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: !isDisabled ? (
    //       <Select
    //         searchable
    //         clearable
    //         w={160}
    //         placeholder="Chọn lý do"
    //         disabled={
    //           dataInWard.status === "LOCK" ||
    //           sourceCode ||
    //           isSave ||
    //           ["DETAIL", "EDIT"].includes(action)
    //         }
    //         data={dataInventoryTransactionType}
    //         value={dataInWard.sourceType?.toString() || ""}
    //         onChange={(value) => {
    //           handleChangeValueInput(value || "", "sourceType");
    //         }}
    //       />
    //     ) : (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         {
    //           dataInventoryTransactionType?.find(
    //             (t) => t.value === dataInWard.sourceType?.toString()
    //           )?.label
    //         }
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: null,
    //   },
    //   {
    //     content: null,
    //   },
    // ],
    haveStatus
      ? [
          {
            content: (
              <Text
                fw={700}
                w={"100px"}
                size="sm"
                style={{ whiteSpace: "normal" }}
                truncate
              >
                Tình trạng
              </Text>
            ),
          },
          { content: null },
          { content: null },
        ]
      : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã số khách hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.cusCode}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chi nhánh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataBranch &&
              dataBranch?.find(
                (i: any) =>
                  String(i?.orgId) === String(dataOrderDetail?.toBranchId),
              )?.orgCode}{" "}
            - {dataOrderDetail.toBranchName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Họ & Tên
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.attribute5 === null ||
            dataOrderDetail?.attribute5 === "0"
              ? dataOrderDetail?.cusName
              : attribute5Data.name}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Kho <span style={{ color: "red" }}>*</span>
          </Text>
        ),
      },
      {
        content: (
          <Select
            key={idInventory}
            className={classesButton.text_input}
            searchable
            clearable
            w={160}
            placeholder="Chọn kho"
            disabled={dataInWard.status === "LOCK"}
            data={dataInventoryGroup
              .filter(
                (item) =>
                  item.inventoryCode.includes("XL") ||
                  item.inventoryCode.includes("HB") ||
                  item.inventoryCode.includes("BH") ||
                  item.inventoryCode.includes("SR"),
              )
              .map((item) => ({
                value: item.inventoryId?.toString() || "",
                label: item.inventoryCode + " - " + item.inventoryName,
              }))}
            value={dataInWard.toInvId?.toString() || ""}
            onChange={(value) => {
              setIdInventory(value);
              handleChangeValueInput(value || "", "subInvId");
              handleChangeValueInput(value || "", "toInvId");
              handleChangeValueInput(null, "toPositionId");
              setCodeAtt3Inv(
                dataInventoryGroup.filter(
                  (item) => String(item.inventoryId) === value,
                )[0]?.attribute3 ?? "",
              );
            }}
          />

          // <Text
          //   w={"150px"}
          //   size="sm"
          //   style={{ whiteSpace: "normal" }}
          //   truncate
          // >
          //   {dataOrderDetail.toInvCode
          //     ? `${dataOrderDetail.toInvCode} - ${
          //         dataOrderDetail.toInvName || ""
          //       }`
          //     : dataOrderDetail.toInvName || ""}
          // </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Số điện thoại
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.attribute5 === null ||
            dataOrderDetail?.attribute5 === "0"
              ? dataOrderDetail?.cusTelephone
              : attribute5Data.phone}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Vị trí <span style={{ color: "red" }}>*</span>
          </Text>
        ),
      },
      // {
      //   content: !isEdit ? (
      //     <Tooltip
      //       label={
      //         dataInWard?.toPositionId
      //           ? dataPosition?.find(
      //               (p) => p.value === dataInWard?.toPositionId?.toString()
      //             )?.label
      //           : "Vui lòng chọn vị trí"
      //       }
      //     >
      //       {/* <Select
      //         searchable
      //         clearable
      //         w={160}
      //         placeholder="Chọn lý do"
      //         disabled={
      //           dataInWard.status === "LOCK" ||
      //           sourceCode ||
      //           isSave ||
      //           ["DETAIL", "EDIT"].includes(action)
      //         }
      //         data={dataInventoryLocation?.map((item) => ({
      //           value: item.id?.toString() || "",
      //           label: item.positionName ?? "",
      //         }))}
      //         onChange={(value) => {
      //           handleChangeValueInput(value || "", "toPositionId");
      //         }}
      //       /> */}
      //       <Select
      //         w={"160px"}
      //         placeholder="Vị trí"
      //         data={dataPosition}
      //         size="sm"
      //         // disabled={
      //         //   !idInventory ||
      //         //   !dataInWard.sourceType ||
      //         //   dataInWard.status === "LOCK" ||
      //         //   isSave
      //         // }
      //         searchable
      //         clearable
      //         value={dataInWard.toPositionId?.toString()}
      //         onChange={(value) => {
      //           setIdInventory(value);
      //           handleChangeValueInput(value, "toPositionId");
      //         }}
      //         nothingFoundMessage={"Không tìm thấy dữ liệu !"}
      //       />
      //     </Tooltip>
      //   ) : (
      //     <Text
      //       w={"150px"}
      //       size="sm"
      //       style={{ whiteSpace: "normal" }}
      //       truncate
      //     >
      //       {dataInWard.toPositionName}{" "}
      //     </Text>
      //   ),
      // },
      {
        content: (
          <Select
            key={dataInWard.toPositionId?.toString()}
            w={"160px"}
            placeholder="Vị trí"
            data={dataPosition}
            className={classesButton.text_input}
            size="sm"
            disabled={
              !dataInWard.toInvId?.toString() ||
              dataInWard.status === "LOCK" ||
              codeAtt3Inv === "BH"
            }
            // disabled={
            //   !idInventory ||
            //   !dataInWard.sourceType ||
            //   dataInWard.status === "LOCK" ||
            //   isSave
            // }
            searchable
            clearable
            value={dataInWard.toPositionId?.toString()}
            onChange={(value) => {
              handleChangeValueInput(value, "toPositionId");
            }}
            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
          />
        ),
      },
    ],
    !isLocked
      ? [
          {
            content: (
              <Text fw={700} size={"sm"}>
                Tình trạng
              </Text>
            ),
          },
          {
            content: <></>,
          },
          {
            content: (
              <Select
                w={"160px"}
                placeholder="Tình trạng"
                data={dataSerialStatus}
                size="sm"
                disabled={
                  !dataInWard.sourceType ||
                  dataInWard.status === "LOCK" ||
                  isSave ||
                  isLocked ||
                  !dataSerialOnHand ||
                  dataSerialOnHand.length === 0
                }
                searchable
                clearable
                onChange={(e) => setSerialStatusSelectAll(e ? e : "")}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            ),
          },
        ]
      : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            {/* Quận/Huyện */}
            Tỉnh/Thành
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {dataOrderDetail.cusDestrictName} */}
            {dataCommuneMoi[0]?.att1 || ""}
            {/* {datadiaChi.province || ""} */}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            ĐĐ làm việc
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.toBranchAddress}
          </Text>
        ),
      },
    ],
    [
      // {
      //   content: (
      //     <Text
      //       fw={700}
      //       w={"100px"}
      //       size="sm"
      //       style={{ whiteSpace: "normal" }}
      //       truncate
      //     >
      //       Quận/Huyện
      //     </Text>
      //   ),
      // },
      // {
      //   content: (
      //     <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
      //       {/* {dataOrderDetail.cusDestrictName} */}
      //       {dataCommuneMoi[0]?.att1 || ""}
      //       {/* {datadiaChi.district || ""} */}
      //     </Text>
      //   ),
      // },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Phường/Xã
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {dataOrderDetail.cusCommuneName} */}
            {dataCommuneMoi[0]?.text || ""}
            {/* {datadiaChi.commune || ""} */}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Người giao dịch
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.createName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa chỉ cụ thể
          </Text>
        ),
      },

      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusAddress || ""}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chức danh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.createRoleName}
          </Text>
        ),
      },
    ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          ></Text>
        ),
      },
      {
        content: (
          <Text
            w={"150px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          ></Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Giao hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {getDeliveryText(dataOrderDetail?.delivery || "")}
          </Text>
        ),
      },
    ],
    // isLocked || isEdit
    //   ?
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Diễn giải chứng từ gốc
          </Text>
        ),
      },
      {
        content: (
          <Text size="sm" w={"500px"}>
            {dataInWard?.sourceDescription}
          </Text>
        ),
        colSpan: 3,
      },
    ],
    // : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Ghi chú
          </Text>
        ),
      },
      {
        content: (
          <TextInput
            error={
              dataInWard?.description && dataInWard.description.length > 300
                ? "Ghi chú không được vượt quá 300 kí tự!"
                : null
            }
            className={classesButton.text_input}
            value={dataInWard?.description ?? ""}
            onChange={(e) => {
              handleChangeValueInput(e.target.value, "description");
            }}
            disabled={isLocked}
            placeholder={isLocked ? "" : "Vui lòng nhập"}
          />
        ),
        colSpan: 3,
      },
    ],
  ];

  return (
    <RenderTable
      headers={headers}
      rows={rows.filter((item) => item.length !== 0)}
    />
  );
};

type RequestOrderReturnInWardProps = {
  dataSearchSourceCodeOption?: any[];
  dataPosition?: any[];
  dataInWard: tblInventoryTransaction;
  dataOrderDetail: any;
  handleChangeValueInput: (value: string | boolean | null, key: string) => void;
  setSourceCode?: (value: any) => void;
  handleKeyDownSourceCode?: (e: any) => void;
  sourceCode?: any;
  isSave?: boolean;
  setSearchSourceCode?: (newValue: React.SetStateAction<string>) => void;
  isEdit?: boolean;
  isLocked?: boolean;
  haveStatus?: boolean;
  haveSourceCode?: boolean;
  action: string;
  dataSerialStatus?: any[];
  setSerialStatusSelectAll?: any;
  dataSerialOnHand?: any[];
  dataBranch?: any;
  dataInventoryTransactionType?: ComboboxItem[];
};

export default ExchangeReturnInWard;
